import React from 'react';
import { connect } from 'react-redux';
import { Select } from '@nerdwallet/currency';

import { RENT_VS_BUY } from '../../../../lib/analytics-constants';
import {
  RentVsBuyInput,
  inputOnChange,
  BedrockInterface,
} from '../../../../lib/utils';
import { loanTerms as LoanTermOptions } from '../shared/constants';
import useAnalytics from '../../../../lib/analytics/use-analytics';
import { debouncedTrackInputEvent } from '../../../../lib/analytics/trackers';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const LoanTermInput: React.FC<RentVsBuyInput> = ({
  value,
  errorMessage,
  dispatch,
  analytics,
  label = '',
  className = '',
  tooltip = '',
  fullWidth,
}) => {
  const segmentAbstract = useAnalytics();
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        field_value: e.target.value,
        entityName: 'loan_term',
        field_type: 'drop-down',
        field: 'Loan Term',
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'loanTerm',
      calculator: RENT_VS_BUY,
      inputType: 'number',
    });
  };

  return (
    <Select
      options={LoanTermOptions}
      value={value}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      label={label}
      className={className}
      tooltip={tooltip}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  value: state?.rentvsbuyCalculator?.inputs?.loanTerm,
  errorMessage: state?.validations?.loanTerm?.[0],
});

export default connect(mapStateToProps)(LoanTermInput);
